// extracted by mini-css-extract-plugin
export default {"container":"NxPage__container--oQXRUX8TllruXx0WyCyj"};